import { render, staticRenderFns } from "./detailed-calendar-component.vue?vue&type=template&id=6628de28&scoped=true"
import script from "./detailed-calendar-component.vue?vue&type=script&lang=js"
export * from "./detailed-calendar-component.vue?vue&type=script&lang=js"
import style0 from "./detailed-calendar-component.vue?vue&type=style&index=0&id=6628de28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6628de28",
  null
  
)

export default component.exports